<template>
  <svg
    :class="{
      'text-www-color-accent': true,
    }"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.9916 7.49569C14.9916 11.9932 8.99496 16.4907 8.99496 16.4907C8.99496 16.4907 2.99829 11.9932 2.99829 7.49569C2.99829 4.18604 5.68531 1.49902 8.99496 1.49902C12.3046 1.49902 14.9916 4.18604 14.9916 7.49569V7.49569"
      stroke="currentColor"
      stroke-width="1.42421"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.74622 7.49582C6.74622 8.73694 7.75385 9.74457 8.99497 9.74457C10.2361 9.74457 11.2437 8.73694 11.2437 7.49582C11.2437 6.2547 10.2361 5.24707 8.99497 5.24707C7.75385 5.24707 6.74622 6.2547 6.74622 7.49582V7.49582"
      stroke="currentColor"
      stroke-width="1.42421"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
